import { Typography } from '@volvo/vcdk-react';

import type { IAftermarketCampaign } from '@/service/vpc/types/IAftermarketCampaign';

import Dot from '@/components/Dot';
import GoToNativeButton from '@/components/remote-software/components/GoToNativeButton';
import Success from '@/components/remote-software/components/Success';
import { GO_TO_NATIVE_STATUSES } from '@/service/vpc/types/IInstallableCampaign';

type InstallAvailableButtonProps = {
  unitName: string;
  endCustomerUnitId: number;
  campaign: IAftermarketCampaign;
};

const InstallAvailableButton: React.FC<InstallAvailableButtonProps> = ({ unitName, endCustomerUnitId, campaign }) => {
  const installableCampaign = campaign.installableCampaign;
  if (!installableCampaign) return null;

  const { status } = installableCampaign;

  if (status === 'Successful') return <Success />;

  const config = GO_TO_NATIVE_STATUSES.get(status);
  if (!config) return null;

  return (
    <div>
      <GoToNativeButton
        unitName={unitName}
        endCustomerUnitId={endCustomerUnitId}
        aftermarketCampaignTitle={campaign.aftermarketCampaignTitle}
        installableCampaign={installableCampaign}
        buttonText={config.text}
        iconStart={config.iconStart}
        iconEnd={config.iconEnd}
      />
      {config.statusText && config.statusVariant && (
        <div className="mt-2 flex items-center gap-2">
          <Dot variant={config.statusVariant} />
          <Typography variant="caption1">{config.statusText}</Typography>
        </div>
      )}
    </div>
  );
};

export default InstallAvailableButton;
